




// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import Edit from '@/components/administration/activity/edit/EditContent.vue'
import { getDefaultAloActivity, AloActivity } from '@/models/alo/AloActivity';
import { AloMedia, getDefaultAloMedia } from '@/models/alo/AloMedia';
import cloneDeep from 'clone-deep';


@Component({
  name: 'ReadImage',    
   props: {
    activity:{      
      default:getDefaultAloActivity()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadImage extends Vue {
  private activity!:AloActivity
  private loading!:boolean
  private saving = false

  get configuration(){
    return this.$store.myGetters.configuration
  }

  get name(){
    return `photo ${this.activity.libelle}`
  }

 onImagesAdded(images:Array<AloMedia>) {
    //@ts-ignore
    const modified = cloneDeep(this.activity) as AloActivity
    modified.images = images
    this.saveData(modified,"Image(s) ajoutée(s)")
  }

  onImageDeleted(images:Array<AloMedia>){
    //@ts-ignore
    const modified = cloneDeep(this.activity) as AloActivity
    modified.images = images
    this.saveData(modified,"Image supprimée")
  }  

  onOrderChange(images:Array<AloMedia>) {
    const modified = cloneDeep(this.activity) as AloActivity
    modified.images = images
    this.saveData(modified,"Ordre des image(s) modifiée(s)")  
  }

  saveData(modified:AloActivity,message:string = "") {        
    this.saving = true
    this.$store.myActions.ADM_ACTIVITY_SAVE_REQUEST(modified).then(() => {
      if(message.length>0 ) this.$store.myActions.UI_ADD_SNACK_MESSAGE(message)                  
    }).finally(()=>{      
      this.saving = false
    })        
  }


   /*
  get defaultCrops(){
    return this.$store.myGetters.configuration.activity.crops
  }
  get maxImages(){
    return this.$store.myGetters.configuration.activity.maxImages
  }*/

/*
  onOrderChange(temPhotosIds:string) {
   this.saveImages(temPhotosIds,"Modification de l'ordre des images sauvegardé")
  }

  onImageAdded(temPhotosIds:string){
    this.saveImages(temPhotosIds,"Ajout image(s) sauvegardé")
  }

  onImageDeleted(temPhotosIds:string){
    this.saveImages(temPhotosIds,"Image supprimée")
  }  
  
  saveImages(temPhotosIds:string,message:string){
    this.saving = true
    const temUplPhoto = (temPhotosIds && temPhotosIds.length>0)?parseInt(temPhotosIds.split(',')[0]):0
    const modified = {...this.activity,temPhotosIds,temUplPhoto}
    this.$store.myActions.ADM_ACTIVITY_SAVE_REQUEST(modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(message)                  
      }).finally(() => {
        this.saving = false
      })
  }
*/
}
